import { useNavigate } from "react-router-dom";
import CloseButton from "../../atoms/buttons/CloseButton";

const Content = ({
  children,
  isConfirmedPage = false,
  showRemoveOnDesktop = false,
  onClose,
}) => {
  const navigate = useNavigate();
  const handleClose = onClose || (() => navigate("/"));

  return (
    <div
      className={`${
        isConfirmedPage
          ? "px-0 py-0 h-full bg-white md:bg-gray-100 lg:bg-white"
          : "px-4 py-4"
      } md:px-12 md:py-8 lg:pt-4 lg:pb-10 lg:px-6`}
    >
      <div
        className={`w-full bg-white 
        ${isConfirmedPage ? "rounded-none md:rounded-lg" : "rounded-lg"} 
        p-6 md:p-12 lg:p-0 h-full`}
      >
        {isConfirmedPage && (
          <div className="absolute block md:hidden lg:block right-2 top-16 lg:right-8 lg:top-8">
            <CloseButton onClick={handleClose} />
          </div>
        )}
        {!isConfirmedPage && showRemoveOnDesktop && (
          <div className="absolute right-8 top-8 hidden lg:block">
            <CloseButton onClick={handleClose} />
          </div>
        )}
        <div className="flex justify-center">
          <div className="w-full max-w-lg">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default Content;
